import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installAuthGate } from "@/lib/authGate";

// Iter 292.6 F-C — global 401 interceptor. Idempotent; installed once at
// app startup so every axios request in the tree benefits.
installAuthGate();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
